(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country-phone-code', {
            parent: 'entity',
            url: '/country-phone-code?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.countryPhoneCode.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country-phone-code/country-phone-codes.html',
                    controller: 'CountryPhoneCodeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('countryPhoneCode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-phone-code-detail', {
            parent: 'entity',
            url: '/country-phone-code/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.countryPhoneCode.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country-phone-code/country-phone-code-detail.html',
                    controller: 'CountryPhoneCodeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('countryPhoneCode');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CountryPhoneCode', function($stateParams, CountryPhoneCode) {
                    return CountryPhoneCode.get({id : $stateParams.id});
                }]
            }
        })
        .state('country-phone-code.new', {
            parent: 'country-phone-code',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country-phone-code/country-phone-code-dialog.html',
                    controller: 'CountryPhoneCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country-phone-code', null, { reload: true });
                }, function() {
                    $state.go('country-phone-code');
                });
            }]
        })
        .state('country-phone-code.edit', {
            parent: 'country-phone-code',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country-phone-code/country-phone-code-dialog.html',
                    controller: 'CountryPhoneCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CountryPhoneCode', function(CountryPhoneCode) {
                            return CountryPhoneCode.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('country-phone-code', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country-phone-code.delete', {
            parent: 'country-phone-code',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country-phone-code/country-phone-code-delete-dialog.html',
                    controller: 'CountryPhoneCodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CountryPhoneCode', function(CountryPhoneCode) {
                            return CountryPhoneCode.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('country-phone-code', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
